// SocketComponent.js
import { useEffect } from "react";
import io from "socket.io-client";
import { getToken } from "../../config/TokenHelper";

// Socket URL from environment variable
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5001";

const SocketComponent = ({ onNewNotification }) => {
  useEffect(() => {
    const isSecure = SOCKET_URL.startsWith("https");
    const socketConnection = io.connect(SOCKET_URL, { secure: isSecure });

    const emitUserConnection = () => {
      const token = getToken();
      if (token && token.authD) {
        const userData = JSON.parse(token.authD);
        socketConnection.emit("connection", { userId: userData._id });
      }
    };

    // Emit on initial connect
    emitUserConnection();

    socketConnection.on("connected", () => {
      console.log("Socket Connected");
    });

    // Re-emit on reconnect so backend rejoins admin room
    socketConnection.on("reconnect", () => {
      console.log("Socket Reconnected");
      emitUserConnection();
    });

    socketConnection.on("new-notification-received", (data) => {
      onNewNotification(data);
    });

    return () => {
      if (socketConnection) {
        socketConnection.disconnect();
      }
    };
  }, [onNewNotification]);

  return null;
};

export default SocketComponent;
